import Link from 'src/components/Link'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import { useSelector } from 'src/redux/hooks'
import styles from './HomeyLoveDashboard.module.css'
import config from 'src/config'
import { getNewsletterStorefront } from 'src/functions/newsletterStorefront'

export default function HomeyLoveDashboard() {
  const wishlistCount = useSelector(state => Object.keys(state.Wunschliste.items).length)
  const storefront = getNewsletterStorefront(config.shop.shop)
  if (!storefront) return null
  return <div className={styles.dashboard} style={storefront.style}>
    <section className={styles.welcome} aria-labelledby='account-welcome'>
      <div>
        <p className={styles.eyebrow}>Mein {storefront.name}</p>
        <h2 id='account-welcome'>Schön, dass Sie da sind.</h2>
        <p>Ihre Bestellungen, Ihre Lieblingsstücke und neue Ideen für Ihr Zuhause – alles an einem Ort.</p>
      </div>
      <span className={styles.session}>Sie sind angemeldet</span>
    </section>
    <nav className={styles.cards} aria-label='Ihr Kundenkonto'>
      <DashboardCard href='/kundenkonto/bestellungen' title='Meine Bestellungen' icon={<LocalMallOutlinedIcon />} action='Bestellungen ansehen'>
        Bestelldetails öffnen und den Versand Ihrer Lieblingsstücke verfolgen.
      </DashboardCard>
      <DashboardCard href='/wunschliste' title='Meine Wunschliste' icon={<FavoriteBorderIcon />} action={wishlistCount ? `${wishlistCount} ${wishlistCount === 1 ? 'Lieblingsstück' : 'Lieblingsstücke'} ansehen` : 'Lieblingsstücke entdecken'}>
        {wishlistCount ? 'Ihre gemerkten Artikel warten auf Sie.' : 'Sammeln Sie mit dem Herz am Produkt Ihre Favoriten.'} Die Wunschliste wird in diesem Browser gespeichert.
      </DashboardCard>
      <DashboardCard href='/kundenkonto/adressen' title='Meine Adressen' icon={<LocationOnOutlinedIcon />} action='Adressen verwalten'>
        Liefer- und Rechnungsadressen für den nächsten Einkauf auswählen und Änderungen für offene Bestellungen anfragen.
      </DashboardCard>
      <DashboardCard href='/kundenkonto/newsletter' title='Newsletter & Interessen' icon={<MailOutlineIcon />} action='Newsletter verwalten'>
        Inspiration und Neuheiten nach Ihrem Geschmack. Themen auswählen, anmelden oder jederzeit abmelden.
      </DashboardCard>
      <DashboardCard href='/kundenkonto/account' title='Anmelden & Sicherheit' icon={<ManageAccountsOutlinedIcon />} action='Anmeldung ansehen'>
        Ihre verwendete E-Mail-Adresse ansehen und sich sicher abmelden.
      </DashboardCard>
    </nav>
    <aside className={styles.service} aria-label='Hilfe und Service'>
      <p>Wir sind für Sie da.</p>
      <Link href='/kontakt'>Kontakt & Hilfe</Link>
      <Link href='/zahlung-und-versand'>Zahlung & Versand</Link>
      <Link href='/widerruf'>Widerruf erklären</Link>
    </aside>
  </div>
}

function DashboardCard({ href, title, icon, action, children }: {
  href: string; title: string; icon: React.ReactNode; action: string; children: React.ReactNode
}) {
  return <Link href={href} className={styles.card}>
    <span className={styles.icon} aria-hidden='true'>{icon}</span>
    <span className={styles.arrow} aria-hidden='true'><ArrowForwardIcon fontSize='small' /></span>
    <h3>{title}</h3><p>{children}</p><strong>{action}</strong>
  </Link>
}
